$(function () {

    // Scrollers

    $("#scroller-step-cards").scroller({
        buttonColor: "green",
        useStaticClone: true,
        showCloneAbove: 768,
        cloneDisplayProp: "flex"
    })

    $("#scroller-pic-cards").scroller({
        buttonColor: "green",
        useStaticClone: true,
        showCloneAbove: 768,
        cloneDisplayProp: "flex",
        cb: scrollerCallback
    })

	function scrollerCallback() {
		var lazyimgs = document.querySelectorAll(".cec-card__outer-link");
        lazyBg(lazyimgs) 
	}

});